import { JSONSchema6 } from "json-schema";

const getChargePermissionSchema: JSONSchema6 = {
    title: "Get Charge Permission",
    description: "Get Charge Permission to determine if this Charge Permission can be used to charge the buyer. You can also use this operation to retrieve buyer details and their shipping address after a successful checkout. You can only retrieve details for 30 days after the time that the Charge Permission was created.",
    properties: {
        "pathParam": {
            title: "chargePermissionId",
            type: "string",
        }
    },
    required: ["pathParam"]
}

export default getChargePermissionSchema